import { render, staticRenderFns } from "./RoomList.vue?vue&type=template&id=6f988a63&scoped=true"
import script from "./RoomList.vue?vue&type=script&lang=js"
export * from "./RoomList.vue?vue&type=script&lang=js"
import style0 from "./RoomList.vue?vue&type=style&index=0&id=6f988a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f988a63",
  null
  
)

export default component.exports